




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class RoleFilter extends Vue {
  @Prop({ required: true, default: () => [] })
  private value!: string[]

  private get roles() {
    const rs: Array<{ value: string; text: string }> = []
    if (this.$auth.isAdmin) {
      rs.push({ value: 'ADMIN', text: this.$tc('users.roles.ADMIN') })
    }
    if (this.$auth.isAdmin || this.$auth.isTenant) {
      rs.push({ value: 'TENANT', text: this.$tc('users.roles.TENANT') })
    }
    rs.push({ value: 'USER', text: this.$tc('users.roles.USER') })
    return rs
  }

  private selection: string[] = this.value

  @Watch('value')
  private valueChanged(val: string[], old: string[]) {
    if (val !== old) {
      this.selection = val
    }
  }

  @Watch('selection')
  private selectionChanged(val: string[], old: string[]) {
    this.$emit('input', val)
  }

  private mounted() {
    if (this.selection.length === 0) {
      this.selection = this.roles.map(r => r.value)
    }
  }
}
